// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__flAhs","heading-primary":"CloseButton_heading-primary__sHarK"};